import {
  RESET,
  SET_NEW_VERSION_AVAILABLE,
  SET_STATE,
} from './actionTypes';

export const reset = () => ({
  type: RESET,
});

export const setState = (payload) => ({
  type: SET_STATE,
  payload,
});

export const setNewApplicationVersionAvailable = (payload) => ({
  type: SET_NEW_VERSION_AVAILABLE,
  payload,
});
